@for (room of rooms; track room; let roomIndex = $index) {
  <tidy-card>
    <tidy-row class="vertical-align-center">
      @if (room?.icon) {
        <tidy-image
          [src]="'assets/img/icons/rooms/' + room?.icon + '.svg'"
          class="header-size" />
      }
      <tidy-text
        [header]="room?.name"
        [translate]="false" />
    </tidy-row>
    @for (toDo of room?.todos; track toDo; let lastToDo = $last; let toDoIndex = $index) {
      @if (toDo?.title !== 'Take Before Photo' && toDo?.title !== 'Take After Photo' && toDo?.title !== 'Take Before Video' && toDo?.title !== 'Take After Video') {
        <tidy-row [ngClass]="!lastToDo ? 'extra-bottom-padding vertical-align-middle' : 'vertical-align-middle'">
          <tidy-image
            [matTooltip]="(toDosProvider?.getToDoTooltip(toDo?.customer_performance || toDo?.performance)) | translate"
            [src]="toDosProvider?.getToDoIcon(toDo?.customer_performance || toDo?.performance)"
            class="body-size clickable-checkbox"
            (click)="toggleTaskPerformance(roomIndex, toDoIndex, toDo)" />
          <span class="selectable-text">{{toDo?.title}}</span>
        </tidy-row>
      }
      @for (option of toDo?.options; track option; let last = $last) {
        @if (option?.value_type !== 'photo' && option?.value_type !== 'photos') {
          <tidy-row [ngClass]="(!last && !lastToDo) ? 'extra-bottom-padding' : ''">
            @if (!isEditingOption(roomIndex, toDoIndex, option.id)) {
              <div class="editable-field" (click)="enterEditMode(roomIndex, toDoIndex, option)">
                <tidy-row class="vertical-align-center">
                  <tidy-text
                    [body]="option?.notes ? (option?.name + ': ' + option?.notes) : option?.name"
                    [translate]="false" />
                  <tidy-image
                    [src]="'assets/svg/create-outline.svg'"
                    class="body-size edit-icon" />
                </tidy-row>
                @if (option?.customer_value || option?.json_value || option?.value) {
                  <tidy-text
                    [body]="'Input: ' + (option?.customer_value || option?.json_value || option?.value)"
                    [translate]="false" />
                } @else {
                  <tidy-text
                    [helper]="'No value added by pro'"
                    [translate]="false" />
                }
              </div>
            } @else {
              <form [formGroup]="editForm">
                <tidy-text
                  [body]="option?.notes ? (option?.name + ': ' + option?.notes) : option?.name"
                  [translate]="false" />
                @if (option?.name === 'Text Area') {
                  <tidy-textarea
                    [label]="'Enter value'"
                    formControlName="value"
                    [form]="editForm.controls['value']"
                    [icon]="'assets/svg/document-text.svg'" />
                }
                @if (option?.name === 'Select') {
                  <tidy-radio-button
                    formControlName="value"
                    [form]="editForm.controls['value']"
                    [items]="editingAllowedValues" />
                }
                @if (option?.name?.includes('Checkbox')) {
                  @for (checkbox of editingAllowedValues; track checkbox.value) {
                    <tidy-checkbox
                      [items]="[checkbox]"
                      [(checked)]="checkbox.checked"
                      (checkedChange)="onCheckboxChange()" />
                  }
                }
                @if (option?.name === 'Count' || option?.name === 'Take Inventory') {
                  <tidy-input
                    formControlName="value"
                    [form]="editForm.controls['value']"
                    [label]="'Enter value'"
                    [icon]="'assets/svg/cube.svg'"
                    inputMode="numeric"
                    [mask]="'number'" />
                }
                <tidy-row class="extra-top-padding">
                  <tidy-text
                    [actionBody]="'Cancel'"
                    (action)="cancelEdit()"
                    class="link" />
                  <span>&nbsp;&nbsp;</span>
                  <tidy-button
                    [text]="'Save'"
                    [action]="saveOptionEdit.bind(this, roomIndex, toDoIndex, option, toDo)"
                    class="primary inline-button" />
                </tidy-row>
              </form>
            }
          </tidy-row>
        }
        @if (option?.value_type?.includes('photo')) {
          <tidy-row [ngClass]="(!last && !lastToDo) ? 'extra-bottom-padding' : ''">
            @if (option?.notes) {
              <tidy-text
                [body]="option?.name + ': ' + option?.notes"
                [translate]="false" />
            }
            @if (!option?.notes) {
              <tidy-text
                [body]="option?.name"
                [translate]="false" />
            }
            @if (option?.value) {
              <tidy-photo-note
                class="full-width no-margin photo-note-job"
                [src]="option?.value" />
            }
            @if (option?.metadata) {
              <div class="timestamp-caption">
                @if (option?.metadata?.location) {
                  <tidy-row>
                    <tidy-text
                      [smallBody]="'Location:'"
                      class="white" /><span>&nbsp;</span>
                    <tidy-text
                      [smallBody]="option?.metadata?.location"
                      class="white" />
                  </tidy-row>
                }
                @if (option?.metadata?.displayDate) {
                  <tidy-row>
                    <tidy-text
                      [smallBody]="'Timestamp:'"
                      class="white" /><span>&nbsp;</span>
                    <tidy-text
                      [smallBody]="(option?.metadata?.displayDate | parseDateTime: 'ddd MMM d') + ' ' + (option?.metadata?.displayDate | parseDateTime: 'h:mma')"
                      class="white" />
                  </tidy-row>
                }
              </div>
            }
            @if (option?.jsonValues?.length) {
              @for (jsonOption of option.jsonValues; track jsonOption) {
                @if (jsonOption?.value) {
                  <tidy-photo-note
                    class="full-width no-margin photo-note-job"
                    [src]="jsonOption?.value" />
                }
                @if (jsonOption?.metadata) {
                  <div class="timestamp-caption">
                    @if (jsonOption?.metadata?.location) {
                      <tidy-row>
                        <tidy-text
                          [smallBody]="'Location:'"
                          class="white" /><span>&nbsp;</span>
                        <tidy-text
                          [smallBody]="jsonOption?.metadata?.location"
                          class="white" />
                      </tidy-row>
                    }
                    @if (jsonOption?.metadata?.displayDate) {
                      <tidy-row>
                        <tidy-text
                          [smallBody]="'Timestamp:'"
                          class="white" /><span>&nbsp;</span>
                        <tidy-text
                          [smallBody]="(jsonOption?.metadata?.displayDate | parseDateTime: 'ddd MMM d') + ' ' + (jsonOption?.metadata?.displayDate | parseDateTime: 'h:mma')"
                          class="white" />
                      </tidy-row>
                    }
                  </div>
                }
              }
            } @else if (option?.json_value) {
              @if (isArray(option.json_value)) {
                @for (photoUrl of option.json_value; track photoUrl) {
                  <tidy-photo-note
                    class="full-width no-margin photo-note-job"
                    [src]="photoUrl" />
                }
              } @else {
                <tidy-photo-note
                  class="full-width no-margin photo-note-job"
                  [src]="option.json_value" />
              }
            }
            @if (!option?.value && !option?.jsonValues?.length && !option?.json_value) {
              <br>
              <tidy-text [helper]="'No photo taken by pro'" />
            }
          </tidy-row>
        }
      }
    }
  </tidy-card>
}
